import React from "react";
import {ReactComponent as INCREASE}  from "./images/IncreaseIcon.svg";
import {ReactComponent as DECREASE}  from "./images/DecreaseIcon.svg";
import {ReactComponent as NO_CHANGE}  from "./images/NoChangeIcon.svg";

export const getMetricBGColorByCount = (count) => {
    if (!count) {
        return "#e8e8e8";
    }

    return count > 0 ? "#F5FAF2BF" : "#FDF2F2";
}

export const getMetricColorByCount = (count) => {
    if (!count) {
        return "#6E6E6E";
    }

    return count > 0 ? "#387E25" : "#E00004";
}


export const getTrendByCount = (count) => {
    if (!count) {
        return <NO_CHANGE/>;
    }

    return count > 0 ? <INCREASE/> : <DECREASE/>;
}


export const getFullMonthYear = (yearMonth) => {
    const date = new Date(`${yearMonth}-01T00:00:00`);
    return `${date.toLocaleString('default', {month: 'long'})} ${date.getFullYear()}`
}

export const getShortMonthYear = (yearMonth) => {
    const date = new Date(`${yearMonth}-01T00:00:00`);
    return `${date.toLocaleString('default', {month: 'short'})} ${date.getFullYear()}`
}

export const isCountIncreased = (count) => {
    if (!count) {
        return null;
    }

    return count > 0;
}

export const getYearMonthStr = (date) => {
    return `${date.getFullYear()}-${date.toLocaleString('default', {month: '2-digit'})}`
}
